"use client";

import { ALLYearTuple } from "@/constants/type";
import { useParams, useSearchParams } from "next/navigation";
import { YEARLYSchedule as Y } from "@/constants/constant-client";
import { Suspense } from "react";
import { SelectSetSearchParam } from "./select-set";

const getWeeklyRanges = (start: Date, end: Date) => {
  let ranges = [];

  let firstMonday = new Date(start);
  firstMonday.setDate(start.getDate() - (start.getDay() === 0 ? 6 : start.getDay() - 1));

  while (firstMonday <= end) {
    let weekEnd = new Date(firstMonday);
    weekEnd.setDate(firstMonday.getDate() + 6);

    ranges.push({ start: firstMonday.toISOString().split("T")[0], end: weekEnd.toISOString().split("T")[0] });
    firstMonday.setDate(firstMonday.getDate() + 7);
  }
  return ranges;
};

function Filter({ paramName }: { paramName: string }) {
  const { year } = useParams<{ year: ALLYearTuple }>();
  const searchParams = useSearchParams();
  const game = searchParams.get(paramName);
  const start = `${game?.substring(0, 4)}-${game?.substring(4, 6)}-${game?.substring(6, 8)}`;
  const end = `${game?.substring(8, 12)}-${game?.substring(12, 14)}-${game?.substring(14, 16)}`;
  const diff = new Date(end).getTime() - new Date(start).getTime();

  if (game && (start === end || 864000000 < diff))
    return (
      <select className="select select-sm w-full max-w-xs" aria-label={paramName} disabled>
        <option>週指定</option>
      </select>
    );
  const weekMap = getWeeklyRanges(
    new Date(Y?.[year]?.pennant?.start ?? "2022-03-25"),
    new Date(Y?.[year]?.pennant?.end ?? "2022-03-25")
  );

  const options = weekMap.map((m) => ({
    val: `${m.start.replaceAll("-", "")}${m.end.replaceAll("-", "")}9`,
    name: `${m.start}  -  ${m.end}`,
  }));

  return (
    <SelectSetSearchParam paramName={paramName}>
      <option value={paramName} disabled>
        週指定
      </option>
      {options.map((m) => (
        <option key={m.name} value={m.val}>
          {m.name}
        </option>
      ))}
    </SelectSetSearchParam>
  );
}
export function WeekFilter({ paramName }: { paramName: string }) {
  return (
    <Suspense
      fallback={
        <select className={"select select-sm w-full max-w-xs"}>
          <option value={paramName} disabled>
            週指定
          </option>
        </select>
      }
    >
      <Filter paramName={paramName} />
    </Suspense>
  );
}
